// Libraries
import React, { FC, useCallback } from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import styled from 'styled-components';

type DropzoneContainerProps = {
  isDragAccept: boolean;
  isDragReject: boolean;
  isFocused: boolean;
};

type DropzoneProps = {
  onFileLoad: (file: Blob | File) => void;
  setFileLoading?: (loading: boolean) => void;
  id?: string;
} & DropzoneOptions;

const getColor = (props: DropzoneContainerProps) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isFocused) {
    return '#2196f3';
  }
  return '#c6c6c6';
};

const DropzoneContainer = styled.div<DropzoneContainerProps>`
  border-color: ${(props) => getColor(props)};
`;

const Dropzone: FC<DropzoneProps> = ({
  onFileLoad,
  setFileLoading,
  id,
  ...options
}) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file: Blob) => {
        const reader = new FileReader();

        reader.onabort = () => console.log('file reading was aborted');
        reader.onerror = () => console.log('file reading has failed');
        reader.onloadstart = () => {
          if (setFileLoading) {
            setFileLoading(true);
          }
        };
        reader.onload = async () => {
          onFileLoad(file);

          if (setFileLoading) {
            setFileLoading(false);
          }
        };

        reader.readAsArrayBuffer(file);
      });
    },
    [onFileLoad]
  );

  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    ...options,
  });

  const files = acceptedFiles.map((file) => (
    <li className="list-none" key={file.name}>
      <strong>{file.name}</strong>
    </li>
  ));

  return (
    <>
      <DropzoneContainer
        {...getRootProps({
          isFocused,
          isDragAccept,
          isDragReject,
          id: id,
          className:
            'flex shrink grow basis-0 flex-col p-5 bg-white-ish border-2 rounded-lg rounded-sm border-dashed outline-none transition-colors motion-reduce:transition-none',
        })}
      >
        <input {...getInputProps()} />
        <p className="text-gray-ish">
          Arrastra y suelta tu(s) archivo(s) aquí o da clic para
          seleccionarlo(s)
        </p>
      </DropzoneContainer>
      {files.length > 0 && (
        <div className="py-3">
          Archivos cargados:
          {files}
        </div>
      )}
    </>
  );
};

export default Dropzone;
